import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarOtherIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M10 8.33a1.67 1.67 0 1 0 0 3.34 1.67 1.67 0 0 0 0-3.34Zm-5.83 0a1.67 1.67 0 1 0 0 3.34 1.67 1.67 0 0 0 0-3.34Zm11.66 0a1.67 1.67 0 1 0 0 3.34 1.67 1.67 0 0 0 0-3.34Z"
      fill="#5C64ED"
    />
    <path
      d="M10 8.33a1.67 1.67 0 1 0 0 3.34 1.67 1.67 0 0 0 0-3.34Zm-5.83 0a1.67 1.67 0 1 0 0 3.34 1.67 1.67 0 0 0 0-3.34Zm11.66 0a1.67 1.67 0 1 0 0 3.34 1.67 1.67 0 0 0 0-3.34Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1="8.33"
        x2="10"
        y2="11.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarOtherIcon.defaultProps = {
  sx: null,
}
